// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__V3ByO","title":"ErrorPage_title__1AyJK","icon":"ErrorPage_icon__nmtTr","button":"ErrorPage_button__K3hue"};